import { render, staticRenderFns } from "./ClockingInput.vue?vue&type=template&id=1d96b0bc&scoped=true"
import script from "./ClockingInput.vue?vue&type=script&lang=js"
export * from "./ClockingInput.vue?vue&type=script&lang=js"
import style0 from "./ClockingInput.vue?vue&type=style&index=0&id=1d96b0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96b0bc",
  null
  
)

export default component.exports